<template>
  <section style="position: relative">
    <div class="index-flow" @click="handleFlowShow">诉求办理流程图</div>
    <section class="index-statics content-row">
      <el-row :gutter="1">
        <el-col :span="6" style="background: #d5ecf6">
          <el-row>
            <el-col :span="9" style="text-align: center;">
              <i class="el-icon-data-line" style="color: #F59B22;font-size: 60px;margin-top: 30px"></i>
            </el-col>
            <el-col :span="14">
              <div style="margin-top: 28px;text-align: center;width: 100px">
                <div style="font-size: 25px;margin-bottom: 3px;font-weight: 600">投诉总数</div>
                <span style="font-size: 28px;font-weight: 600">{{appealCount.total}}</span>
              </div>
            </el-col>
            <el-col :span="1">
              <div style="width: 1px;height: 80px;margin-top: 20px;background: #a2aab6"></div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6" style="background: #d5ecf6">
          <el-row>
            <el-col :span="9" style="text-align: center;">
              <i class="el-icon-guide" style="color: #4898ff;font-size: 60px;margin-top: 30px"></i>
            </el-col>
            <el-col :span="14">
              <div style="margin-top: 28px;text-align: center;width: 100px">
                <div style="font-size: 25px;margin-bottom: 3px;font-weight: 600">转办数量</div>
                <span style="font-size: 28px;font-weight: 600">{{appealCount.wait}}</span>
              </div>
            </el-col>
            <el-col :span="1">
              <div style="width: 1px;height: 80px;margin-top: 20px;background: #a2aab6"></div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6" style="background: #d5ecf6">
          <el-row>
            <el-col :span="9" style="text-align: center;">
              <i class="el-icon-document-checked" style="color: #2fbb72;font-size: 60px;margin-top: 30px"></i>
            </el-col>
            <el-col :span="14">
              <div style="margin-top: 28px;text-align: center;width: 100px">
                <div style="font-size: 25px;margin-bottom: 3px;font-weight: 600">办结数量</div>
                <span style="font-size: 28px;font-weight: 600">{{appealCount.finish}}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row style="cursor: pointer;margin-left: 10px;background: #f1ede4" @click.native="handleAppealRegister">
            <el-col :span="12">
              <div style="color: #a30014;font-size: 30px;font-weight: 800;margin: 10px;margin-left: 45px;">诉 求</div>
              <span style="color: #a30014;font-size: 30px;font-weight: 800;margin: 10px;margin-left: 45px;">登 记</span>
            </el-col>
            <el-col :span="12">
              <img src="/static/ic_pointer.png" class="appeal-pointer"/>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </section>
    <el-row :gutter="10" style="margin-top: 20px">
      <el-col :span="16">
        <div class="index-block">
          <div class="title-block">
            <span class="title-info" style="border-top: 2px solid #0068bc;padding: 5px 10px;">诉求反馈</span>
          </div>
          <el-table
            :header-cell-style="{background:'#0068bc',color:'#FFF','text-align':'center','font-weight':'800','font-size':'16px'}"
            :cell-style="{'font-size':'16px'}"
            :height="blockHeight"
            stripe
            ref="table"
            @cell-mouse-enter="onMouseEnterTable"
            @cell-mouse-leave="onMouseLeaveTable"
            :data="appealProgressData">
            <el-table-column
              prop="enterpriseName"
              label="企业名称"
              align="center">
            </el-table-column>
            <el-table-column
              prop="status"
              label="当前状态"
              align="center"
              width="300"
              :formatter="statusFormatter">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="诉求日期"
              align="center"
              width="200"
              :formatter="timeFormatter">
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="index-block" :style="{'height':blockHeight+30+'px'}">
          <div class="title-block">
            <span class="notify-title-info">通知公告</span>
            <div @click="handleToNotifyTab" class="more"><i class="el-icon-more"></i></div>
          </div>
          <div class="content-block">
            <el-row :gutter="1" v-for="item in notifyFileData" :key="item.id" class="content-list-item">
              <el-col :span="1">
                <div class="content-list-item-dot"></div>
              </el-col>
              <el-col :span="19">
                <div class="content-title" @click="handleNotifyDetail(item.id)">{{item.title}}</div>
              </el-col>
              <el-col :span="4">
                <div class="content-time">[{{item.createTime.substring(5,10)}}]</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog width="50%" :visible.sync="isShowFlow" :close-on-click-modal="true" center>
      <img src="/static/ic_flow.png" style="width: 95%"/>
    </el-dialog>
  </section>
</template>
<script>
  import { appealInfoIndex, notifyFileIndex, dynamicDutyIndex, portalStatics} from '@/api/restapi.js'
  export default {
    data () {
      return {
        blockHeight: (document.documentElement.clientHeight - 529)<346? 346:document.documentElement.clientHeight - 529,
        isShowFlow: false,
        appealProgressData: [],
        notifyFileData: [],
        dynamicDutyData: [],
        autoScroll: '',
        appealCount: {
          finish: 0,
          wait: 0,
          total: 0
        },
        handleStatusDic: [{
          code: 'wait',
          name: '待处理'
        },{
          code: 'distribution',
          name: '已分配'
        },{
          code: 'unhandle',
          name: '进入司法程序'
        },{
          code: 'receive',
          name: '已受理'
        },{
          code: 'finish',
          name: '已清偿'
        },{
          code: 'withdraw',
          name: '不属于受理范围'
        }]
      }
    },
    mounted () {
      appealInfoIndex().then(res => {
        if (res.data.code === 0) {
          this.appealProgressData = res.data.data
          this.onMouseLeaveTable()
        }
      })
      notifyFileIndex().then(res => {
        if (res.data.code === 0) {
          this.notifyFileData = res.data.data
        }
      })
      dynamicDutyIndex().then(res => {
        if (res.data.code === 0) {
          this.dynamicDutyData = res.data.data
        }
      })
      portalStatics().then(res => {
        if (res.data.code === 0) {
          this.appealCount = res.data.data
        }
      })
    },
    methods: {
      onMouseEnterTable() {
        if (this.autoScroll){
          clearInterval(this.autoScroll)
          this.autoScroll = null
        }
      },
      onMouseLeaveTable(){
        if (this.autoScroll) {
          return
        }
        const table = this.$refs.table
        // 拿到表格中承载数据的div元素
        const divData = table.bodyWrapper
        // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
        this.autoScroll = setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 1
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          if (divData.clientHeight + divData.scrollTop >= divData.scrollHeight) {
            // 重置table距离顶部距离
            divData.scrollTop = 0
          }
        }, 50)
      },
      handleFlowShow () {
        this.isShowFlow = true
      },
      handleAppealRegister () {
        this.$router.push('/portal/appealInfo')
      },
      handleToNotifyTab () {
        this.$router.push('/portal/notify')
      },
      handleNotifyDetail (id) {
        this.$router.push('/portal/notifyDetail?id='+id)
      },
      handleToDutyTab () {
        this.$router.push('/portal/duty/list')
      },
      handleDutyDetail (id) {
        this.$router.push('/portal/duty/detail?id='+id)
      },
      timeFormatter (row, index) {
        return row.createTime.substring(0,10)
      },
      contentFormatter (row, col) {
        return row.appealContent.substring(0,46) + (row.appealContent.length<47?'':'...')
      },
      statusFormatter (row, index) {
        let name = ''
        this.handleStatusDic.forEach(s => {
          if (s.code === row.status) {
            name = s.name
          }
        })
        return name
      }
    }
  }
</script>
<style>
  .index-statics {
    margin: 10px auto;
  }
  .index-statics .el-row{
    height: 120px;
  }
  .index-statics .el-row .el-col {
    height: 120px;
  }
  .index-block {
    padding: 0 0 5px 0;
    background: #FFFFFF;
  }
  .title-block {
    height: 30px;
    line-height: 30px;
  }
  .more {
    text-align: right;
    display: inline;
    float: right;
    padding-right: 5px;
    cursor: pointer;
  }
  .title-info {
    color: #0068bc;
    padding-bottom: 5px;
    font-weight: 700;
  }
  .notify-title-info {
    background: #0068bc;
    color: #FFFFFF;
    font-weight: 700;
    display: inline-block;
    padding: 0px 10px;
  }
  .content-block {
    border-top: 1px solid #0068bc;
    padding: 0 8px;
  }
  .content-list-item {
    margin-top: 15px;
    font-size: 14px;
    cursor: pointer;
    height: 20px;
    line-height: 20px;
  }
  .content-list-item .content-list-item-dot{
    margin-top: 7px;
    height: 4px;
    width: 4px;
    background: #0068bc;
  }
  .content-list-item .content-title {
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space:nowrap;
    height: 18px;
    font-size: 15px;
  }
  .content-list-item .content-time {
    height: 18px;
    text-align: right;
    color: #ABABAB;
    font-size: 14px;
  }
  .contact-block {
    background: #FFFFFF;
    padding-bottom: 10px;
  }
  .contact-block .contact-block-title {
    height: 40px;
    line-height: 40px;
    background: #0068bc;
    color: #FFFFFF;
    font-size: 22px;
    padding: 5px 8px;
  }
  @keyframes scaleDraw{
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(1.1);
    }
    50% {
      transform: scale(1);
    }
    75% {
      transform: scale(1.1);
    }
  }
  .el-table--scrollable-y ::-webkit-scrollbar {
    display: none;
  }
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 1px;
  }
  .appeal-pointer {
    width: 80%;
    margin-top: 5px;
    -webkit-animation-name: scaleDraw;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 4s;
  }
  .index-flow {
    position: absolute;
    left: -24px;
    top: 250px;
    font-size: 14px;
    padding-top: 5px;
    padding-bottom: 5px;
    border: 1px solid #0068bc;
    border-radius: 4px;
    color: #0068bc;
    width: 22px;
    background: #FFFFFF;
    text-align: center;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/Index.vue